import { Store } from '@ngrx/store';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
// Services
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { FolderOperationsService } from 'FoldersApp/services/folder-operations.service';
import { ToastMessagesService } from 'NewAngular/features/components/toast-messages/toast-messages.service';
// NgRx
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import { SELECTED_FOLDERABLE_OPERATION_SLICE_KEY } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.reducer';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i2 from "FoldersApp/services/folder-operations.service";
import * as i3 from "@ngrx/store";
import * as i4 from "NewAngular/features/components/toast-messages/toast-messages.service";
import * as i5 from "FoldersApp/services/selected-folderable.service";
/**
 * Modal that handles deleting folderable items.
 */
export class FolderableDeleteModalDirective {
    constructor(folderableCollectionService, folderOperationsService, store, toastMessagesService, selectedFolderableService) {
        this.folderableCollectionService = folderableCollectionService;
        this.folderOperationsService = folderOperationsService;
        this.store = store;
        this.toastMessagesService = toastMessagesService;
        this.selectedFolderableService = selectedFolderableService;
        this.SELECTED_FOLDERABLE_OPERATION_SLICE_KEY = SELECTED_FOLDERABLE_OPERATION_SLICE_KEY;
        this.setSelectedFolderableOperation = setSelectedFolderableOperation;
    }
    deleteFolderableItem(item) {
        if (item.itemType === FolderableType.FOLDER) {
            this.deleteFolder(item);
        }
        else {
            this.deleteFile(item);
        }
    }
    deleteFolder(item) {
        this.folderOperationsService.deleteFolder(item.id).subscribe({
            next: (response) => {
                // If the user deleted the view root folder, change the view root to be the deleted folder's parent.
                // If the deleted folder was an orphan, change the view root to My YCharts.
                const viewRootFolderId = this.folderableCollectionService.viewRootFolder?.id;
                if (item.id === viewRootFolderId) {
                    const params = {
                        ...this.folderableCollectionService.dataParams,
                        viewRootFolderId: item.ancestorFolderId,
                    };
                    this.refreshData(params);
                }
                else {
                    this.refreshData();
                }
                this.toastMessagesService.addMessage(response.message);
            },
            error: (response) => {
                this.toastMessagesService.addMessage(response.error.error_message, ToastMessageType.ERROR);
            },
        });
    }
    deleteFile(item) {
        this.getDeleteFileObservable(item).subscribe({
            next: (response) => {
                this.refreshData();
                // If there is a selected item, and the selected item was deleted, clear the selection.
                if (this.selectedFolderableService &&
                    item.id === this.selectedFolderableService.getSelection()?.item.id) {
                    this.selectedFolderableService.clearSelection();
                }
                this.toastMessagesService.addMessage(response.message);
            },
            error: () => {
                this.toastMessagesService.addMessage(this.deleteFileErrorMessage, ToastMessageType.ERROR);
            },
        });
    }
    /**
     * Refresh the folder data rendered in the component.
     */
    refreshData(params) {
        this.folderableCollectionService.refreshData(params);
    }
}
FolderableDeleteModalDirective.ɵfac = function FolderableDeleteModalDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableDeleteModalDirective)(i0.ɵɵdirectiveInject(i1.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i2.FolderOperationsService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.ToastMessagesService), i0.ɵɵdirectiveInject(i5.SelectedFolderableService, 8)); };
FolderableDeleteModalDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FolderableDeleteModalDirective, inputs: { deleteFileErrorMessage: "deleteFileErrorMessage" } });
